import React from 'react';

type IUnionPayCardIconProps = React.SVGProps<SVGSVGElement>;

const UnionPayCardIcon: React.FC<IUnionPayCardIconProps> = ({ width = 34, height = 22, ...props }) => (
   <svg
      viewBox="0 0 24 16"
      xmlns="http://www.w3.org/2000/svg"
      role="presentation"
      focusable="false"
      width={width}
      height={height}
      {...props}
   >
      <path
         d="M4.546 0h5.794c.808 0 1.311.726 1.123 1.619L8.765 14.368c-.19.89-1 1.616-1.81 1.616H1.164c-.808 0-1.312-.726-1.123-1.616L2.738 1.619C2.927.726 3.736 0 4.546 0"
         fill="#dd2423"
      />
      <path
         d="M9.858 0h6.662c.809 0 .444.726.254 1.619l-2.697 12.749c-.19.89-.13 1.616-.94 1.616H6.474c-.81 0-1.312-.726-1.122-1.616L8.05 1.619C8.241.726 9.05 0 9.858 0"
         fill="#16315e"
      />
      <path
         d="M16.256 0h5.794c.81 0 1.313.726 1.122 1.619l-2.697 12.749c-.19.89-1 1.616-1.81 1.616h-5.791c-.81 0-1.313-.726-1.123-1.616l2.697-12.749C14.637.726 15.446 0 16.256 0"
         fill="#036862"
      />
   </svg>
);

export default UnionPayCardIcon;
